module.exports = __webpack_public_path__ + "static/img/kechuang.26164b08.png";